import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class MovuRobotics_get_location_container_by_name_warehouseService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { locationName: string, warehouseName: string }): 
  Promise<{ result: { Id?: number, IsLoose?: boolean, Name?: string, TypeId?: number, WarehouseId?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.locationName)) {
      $missingRequiredInParams.push('\'locationName\'');
    }
    if (isNil($inParams.warehouseName)) {
      $missingRequiredInParams.push('\'warehouseName\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      locationName: string, warehouseName: string    }) {
        if(isNil($inParams.locationName)) {
          return true; 
        }
        if(isNil($inParams.warehouseName)) {
          return true; 
        }
      return false;
    }
}
